import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { MesaTableEntry } from './MesaTableEntry';
import { TableEntry } from './TableEntry';
import TipSelectionScreen from '../features/customer/screens/TipSelectionScreen';
import AzulCheckoutScreen from '../features/customer/payment/screens/AzulCheckoutScreen';
import StripeCheckoutScreen from '../features/customer/payment/screens/StripeCheckoutScreen';
import PaymentProcessingScreen from '../features/customer/payment/screens/PaymentProcessingScreen';
import PaymentBreakdownScreen from '../features/customer/screens/PaymentBreakdownScreen';
import CardNetCheckoutScreen from '../features/customer/payment/screens/CardNetCheckoutScreen';
import PaymentSuccessScreen from '../features/customer/screens/PaymentSuccessScreen';
import PaymentSuccessMailOptionScreen from '../features/customer/screens/PaymentSuccessMailOptionScreen';
import ThankYouGoodbyeScreen from '../features/customer/screens/ThankYouGoodbyeScreen';
import PosPaymentSuccess from '../features/customer/payment/screens/PaymentSuccess';
import PayLanding from '../features/customer/screens/PayLanding';
import { isPayDomain } from '../config/domain';

/**
 * Guard: on pay domain, never allow admin paths. Redirect to payment home.
 */
function PayDomainGuard({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  useEffect(() => {
    if (!isPayDomain) return;
    if (
      location.pathname.startsWith('/admin') ||
      location.pathname.startsWith('/super-admin') ||
      location.pathname === '/login'
    ) {
      window.location.href = '/';
    }
  }, [location.pathname]);

  return <>{children}</>;
}

const PaymentRoutes: React.FC = () => {
  return (
    <PayDomainGuard>
      <Routes>
        <Route path="/" element={<PayLanding />} />

        {/* Mesa entry: /m/:mesaId (canonical). Legacy /mesa/:mesaId redirects here. */}
        <Route path="/m/:mesaId" element={<MesaTableEntry />} />
        <Route path="/mesa/:mesaId" element={<Navigate to="/m/:mesaId" replace />} />
        <Route path="/t/:ticketId" element={<TableEntry />} />

        <Route path="/tip-selection" element={<TipSelectionScreen />} />
        <Route path="/pos-payment-success" element={<PosPaymentSuccess />} />
        <Route path="/azul-checkout" element={<AzulCheckoutScreen />} />
        <Route path="/stripe-checkout" element={<StripeCheckoutScreen />} />
        <Route path="/cardnet-checkout" element={<CardNetCheckoutScreen />} />
        <Route path="/payment-processing" element={<PaymentProcessingScreen />} />
        <Route path="/payment-breakdown" element={<PaymentBreakdownScreen />} />
        <Route path="/payment-success" element={<PaymentSuccessScreen />} />
        <Route path="/payment-success-options" element={<PaymentSuccessMailOptionScreen />} />
        <Route path="/thank-you-goodbye" element={<ThankYouGoodbyeScreen />} />

        {/* Catch-all: stay on pay app (e.g. unknown path → landing) */}
        <Route path="*" element={<PayLanding />} />
      </Routes>
    </PayDomainGuard>
  );
};

export default PaymentRoutes;
